// src/components/aols/aeo/OLSupdates/OLS2900/OLS2921.tsx
import React, { useEffect } from "react";
import { Layout, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";
import { InlineShareButtons } from "sharethis-reactjs";
import Footer from "../../../../dev/utils/Footer/Footer";
import { updates2900 } from "./OLS2900";
import { useFirebase } from "../../../../dev/Firebase/Firebase";

const { Title, Paragraph } = Typography;

const UpdateContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 40px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpdateContent = styled.div`
  max-width: 800px;
  width: 100%;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  text-align: center;
`;

const UpdateTitle = styled(Title)`
  && {
    color: #ffcc00 !important;
    margin-bottom: 20px;
  }
`;

const UpdateParagraph = styled(Paragraph)`
  && {
    color: #fff !important;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 24px;
  }
`;

const UpdateLink = styled.a`
  color: #ffaa00 !important;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;

  &:hover {
    color: #ffcc00 !important;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }
`;

const HighlightedText = styled.span`
  font-size: 48px;
  color: #ffcc00;
`;

const UpdateImage = styled.img`
  max-width: 100%;
  border-radius: 8px;
  margin: 20px 0;
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const ShareThisWrapper = styled.div`
  margin-top: 20px;
  padding: 10px;
  background: #1a1a1a;
  border-radius: 8px;
  display: flex;
  justify-content: center;

  .st-btn {
    border: 1px solid #ffcc00 !important;
    border-radius: 4px !important;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    &:focus {
      outline: 2px solid #40c4ff;
      outline-offset: 2px;
    }
  }

  .st-total {
    color: #fff !important;
    font-size: 16px;
  }
`;

const OLS2921: React.FC = () => {
  console.log("OLS2921 component rendering - updates2900:", updates2900);
  const update = updates2900.find((u) => u.id === "2921");
  const { logEvent } = useFirebase();

  useEffect(() => {
    logEvent("page_view", { page_path: "/olsupdates/ols2900/2921" });
    logEvent("post_viewed", { post_id: "2921", post_title: "OLSLM: 2921.123.3410" });
  }, [logEvent]);

  if (!update) {
    console.log("Update 2921 not found in updates2900");
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "OLSLM: 2921.123.3410 - onelightsystem OLS",
    description:
      "Discover the latest OLSLM update for onelightsystem OLS, showcasing Sun Light Meditation advancements and resources for our global community.",
    url: "https://www.olsme.com/olsupdates/ols2900/2921",
    datePublished: "2025-05-11",
    author: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
    },
    publisher: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.olsme.com/olsupdates/ols2900/2921",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "OLS2900",
          item: "https://www.olsme.com/olsupdates/ols2900",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "OLSLM: 2921.123.3410",
          item: "https://www.olsme.com/olsupdates/ols2900/2921",
        },
      ],
    },
  };

  return (
    <Layout>
      <Helmet>
        <title>OLSLM: 2921.123.3410 - onelightsystem OLS</title>
        <meta
          name="description"
          content="Discover the latest OLSLM update for onelightsystem OLS, showcasing Sun Light Meditation advancements and resources for our global community."
        />
        <meta
          name="keywords"
          content="OLSLM update, onelightsystem OLS, Sun Light Meditation, OLS updates, Light Civilization, meditation education, Firebase Analytics"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="onelightsystem OLS" />
        <link
          rel="canonical"
          href="https://www.olsme.com/olsupdates/ols2900/2921"
        />
        <meta
          property="og:title"
          content="OLSLM: 2921.123.3410 - onelightsystem OLS"
        />
        <meta
          property="og:description"
          content="Discover the latest OLSLM update for onelightsystem OLS, showcasing Sun Light Meditation advancements and resources for our global community."
        />
        <meta
          property="og:url"
          content="https://www.olsme.com/olsupdates/ols2900/2921"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.2.123.png?alt=media&token=2f447a9f-51f8-4ebf-8c83-3b6dea46ab3d"
        />
        <meta
          property="og:image:alt"
          content="OLSLM Update 2921.123.3410 - Sun Light Meditation"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="onelightsystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta
          name="twitter:title"
          content="OLSLM: 2921.123.3410 - onelightsystem OLS"
        />
        <meta
          name="twitter:description"
          content="Discover the latest OLSLM update for onelightsystem OLS, showcasing Sun Light Meditation advancements and resources for our global community."
        />
        <meta
          name="twitter:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.2.123.png?alt=media&token=2f447a9f-51f8-4ebf-8c83-3b6dea46ab3d"
        />
        <meta
          name="twitter:image:alt"
          content="OLSLM Update 2921.123.3410 - Sun Light Meditation"
        />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <BreadcrumbWrapper>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to="/">
                  <HomeOutlined /> Home
                </Link>
              ),
            },
            {
              title: <Link to="/olsupdates">OLS Updates</Link>,
            },
            {
              title: <Link to="/olsupdates/ols2900">OLS2900</Link>,
            },
            {
              title: "OLSLM: 2921.123.3410",
            },
          ]}
        />
      </BreadcrumbWrapper>

      <UpdateContainer>
        <UpdateContent>
          <UpdateTitle level={1}>OLSLM: 2921.123.3410</UpdateTitle>
          <UpdateParagraph>
            [ 729.2.123.3399, 729.13.123.3399, 1825.1.123.3402, 2190.1.123.3403 (OLS student) ]
          </UpdateParagraph>
          <UpdateParagraph>
            We’re thrilled to share OLSLM Update 2921, a radiant milestone in our journey toward a Sun Light Civilization! This update highlights the latest advancements in Sun Light Meditation, featuring new meditation sessions and resources for our global community. With restored Firebase Analytics, we’re now empowered to track user engagement, ensuring a seamless experience for all OLS students and members.
          </UpdateParagraph>
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/729.-olsm__2lh-123-2-37:5?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 729.2.123.3399. video on Odysee"
            >
              <HighlightedText>729.2.123.3399.</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.2.123.png?alt=media&token=2f447a9f-51f8-4ebf-8c83-3b6dea46ab3d"
            alt="OLSLM Update 729.2.123.3399. - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/729.-olsm____13lh-123-2-37:8?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 729.13.123.3399. video on Odysee"
            >
              <HighlightedText>729.13.123.3399.</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.13.123..37.png?alt=media&token=012bb9ca-31d8-4d15-97ea-147a6b079e65"
            alt="OLSLM Update 729.13.123.3399. - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/1825.OLSLM-1Lh-%28active-meditation%29-123.4.23.708a---720WebShareName:b?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 1825.1.123.3402. video on Odysee"
            >
              <HighlightedText>1825.1.123.3402</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1825.123.1.png?alt=media&token=811b36a7-03ef-43c5-877d-eb960a4229ec"
            alt="OLSLM Update 1825.1.123.3402 - Active Meditation Session"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/2190.OLSLM--1LH--38-123---HD-1080p:7?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 2190.1.123.3403 video on Odysee"
            >
              <HighlightedText>2190.1.123.3403</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F2190.1.123.png?alt=media&token=5c0029b6-d691-4e4a-a94c-e5183951f934"
            alt="OLSLM Update 2190.1.123.3403 - Advanced Meditation Session"
          />
          <UpdateParagraph>
            Join our vibrant community and explore these transformative sessions! Visit{" "}
            <UpdateLink
              href="/OLSStudentProspect"
              aria-label="Join OLS as a student"
            >
              OLS Student Prospect
            </UpdateLink>{" "}
            to start your Sun Light Meditation journey today.
          </UpdateParagraph>

          <ShareThisWrapper>
            <InlineShareButtons
              config={{
                alignment: "center",
                color: "social",
                enabled: true,
                font_size: 14,
                labels: "cta",
                language: "en",
                networks: [
                  "whatsapp",
                  "linkedin",
                  "messenger",
                  "facebook",
                  "twitter",
                  "blogger",
                  "pinterest",
                  "sms",
                ],
                padding: 9,
                radius: 4,
                show_total: true,
                min_count: 10,
                url: "https://www.olsme.com/olsupdates/ols2900/2921",
                image:
                  "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.2.123.png?alt=media&token=2f447a9f-51f8-4ebf-8c83-3b6dea46ab3d",
                description:
                  "Discover the latest OLSLM update for onelightsystem OLS, showcasing Sun Light Meditation advancements and resources for our global community.",
                title: "OLSLM: 2921.123.3410 - onelightsystem OLS",
                message:
                  "Check out this latest OLSLM update from onelightsystem OLS!",
                subject: "OLSLM Update: 2921.123.3410",
                username: "onelightsystem",
              }}
            />
          </ShareThisWrapper>
        </UpdateContent>
      </UpdateContainer>

      <Footer />
    </Layout>
  );
};

export default OLS2921;